import { Button as MuiButton, DialogContent, styled, Typography } from '@mui/material';
import { spacing } from '@mui/system';
import React from 'react';

import { Dialog } from '../../../../general/components/dialog';

const Button = styled(MuiButton)(spacing);

type Props = {
  onClose: () => void;
};

const CMRADlg: React.FC<Props> = ({ onClose }: Props) => {
  return (
    <Dialog title="Invalid Address" onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" align="center">
          We can&apos;t support a CMRA (Commercial Mail Receiving Address).
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          Please enter a different address.
        </Typography>

        <Button color="primary" size="large" onClick={onClose} fullWidth variant="contained" mt={4}>
          Got it
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export { CMRADlg };
